export const BASE_URL = process.env.REACT_APP_BASE_URL;

const API_URLS = {
  // For dashboard APIs
  getStudentsCount: (nurseryId) => `${BASE_URL}/en/api/nursery/students/active-count/?nursery_id=${nurseryId}`,
  getStaffCount: (nurseryId) => `${BASE_URL}/en/api/manage/staff/active-count/?nursery_id=${nurseryId}`,
  getNewcomersCount: (nurseryId) => `${BASE_URL}/en/api/nursery/students/newcomers/?nursery_id=${nurseryId}`,
  getAttendanceDataset: (nurseryId, roomId, startDate, endDate) => `${BASE_URL}/en/api/nursery/checkin_set/count/?start_date=${startDate}&end_date=${endDate}&nursery_id=${nurseryId}&room_id=${roomId}`,
  getGeneralAttendanceDataset: (nurseryId, startDate, endDate) => `${BASE_URL}/en/api/nursery/checkin_set/count/?start_date=${startDate}&end_date=${endDate}&nursery_id=${nurseryId}`,
  getBirthdays: (nurseryId) => `${BASE_URL}/en/api/nursery/students/birthdays/?nursery_id=${nurseryId}`,
  getWorkiversaries: (nurseryId) => `${BASE_URL}/en/api/manage/staff/anniversaries/?nursery_id=${nurseryId}`,
  getEvents: (nurseryId, date) => `${BASE_URL}/en/api/manage/events/filterdevents/?nursery_id=${nurseryId}&date=${date}`,
  getMonthEvents: (userId,nurseryId, startDate, endDate) => `${BASE_URL}/en/api/nursery/users/${userId}/events/${nurseryId}/?start_date=${startDate}&end_date=${endDate}`,
  getLastMessages: (nurseryId) => `${BASE_URL}/en/api/manage/messages/lastfour/?nursery_id=${nurseryId}`,
  getLastFourMessages: (nurseryId) => `${BASE_URL}/en/api/messages/last-unread-or-last/?nursery_id=${nurseryId}&size=4`,
  getSchoolRooms: (nurseryId) => `${BASE_URL}/en/api/nursery/classes/?nursery_id=${nurseryId}`,
  getRoomStaff: (roomId) => `${BASE_URL}/en/api/room/${roomId}/staff/`,
  getRoomStudents: (roomId) => `${BASE_URL}/en/api/room-students/?room_id=${roomId}`,
  getIndividualReport: ({ roomId, staffId, studentId, startDate, endDate }) => {
    if (staffId) {
      return `${BASE_URL}/en/api/nursery/individual/?room_id=${roomId}&staff_id=${staffId}&student_id=${studentId}&start_date=${startDate}&end_date=${endDate}`;
    } else {
      return `${BASE_URL}/en/api/nursery/individual/?room_id=${roomId}&student_id=${studentId}&start_date=${startDate}&end_date=${endDate}`;
    }
  },
  getComparativeReport: ({ roomId, staffId, startDate, endDate }) => {
    if (staffId) {
      return `${BASE_URL}/en/api/nursery/comaprison/?room_id=${roomId}&staff_id=${staffId}&start_date=${startDate}&end_date=${endDate}`;
    } else {
      return `${BASE_URL}/en/api/nursery/comaprison/?room_id=${roomId}&start_date=${startDate}&end_date=${endDate}`;
    }
  },

  getSchools: (adminId) => `en/api/nursery/nurseries/?filter{Owner}=${adminId}`,
  getSchool: (nurseryId) => `en/api/nursery/nurseries/${nurseryId}`,
  createSchool: () => `en/api/nursery/nurseries/`,
  getRooms: (userId, nurseryId) => `${BASE_URL}/en/api/nursery/users/${userId}/classes/${nurseryId}/`,
  getStudentsByClass: (classId) => `${BASE_URL}/en/api/nursery/classes/${classId}/students/`,
  getParents: (userId, nurseryId) => `${BASE_URL}/en/api/nursery/users/${userId}/parents/${nurseryId}/`,
  getStaff: (userId, nurseryId) => `${BASE_URL}/en/api/nursery/users/${userId}/staff/${nurseryId}`,
  getStudents: (userId, nurseryId) => `${BASE_URL}/en/api/nursery/users/${userId}/students/brief/${nurseryId}/`,
  getStudentsAttendance: (nurseryId, date, room_id) => `${BASE_URL}/api/nursery/checkin_set/monthly-attendance?nursery_id=${nurseryId}&month=${date}&room_id=${room_id}`,
  updateStudentContacts: (studentId, contactId) => `${BASE_URL}/en/api/students/${studentId}/contacts/${contactId}/`,
  addStudentContacts: (studentId) => `${BASE_URL}/en/api/students/${studentId}/contacts/new/`,
  getStudent: (studentId) => `${BASE_URL}/en/api/nursery/students/${studentId}/`,
  getStaffDetails: (staffId) => `${BASE_URL}/en/api/manage/staff/${staffId}/`,
  deleteStudent: (studentId) => `${BASE_URL}/en/api/nursery/students/${studentId}/`,
  getStudentContacts: (studentId) => `${BASE_URL}/en/api/students/${studentId}/contacts/`,
  getFeed: (studentId, activityType, cursor, dateRange = {}) => {
    let params = `activity_type=${activityType}`;
    if (cursor) {
      params = params + `&cursor=${encodeURIComponent(cursor)}`;
    }
    if (dateRange.startDate) {
      params = params + `&start_date=${encodeURIComponent(dateRange.startDate)}`;
    }
    if (dateRange.endDate) {
      params = params + `&end_date=${encodeURIComponent(dateRange.endDate)}`;
    }
    return `${BASE_URL}/en/api/student/${studentId}/feeds/?${params}`;
  },
  // At the end of API_URLS
  getStudentMonthlyAttendance: (studentId, month) => `${BASE_URL}/en/api/student-attendance-by-month/?student_id=${studentId}&month=${month}`,
  getStaffIndividualAttendance: (staffId, month, nurseryId) => `${BASE_URL}/en/staff/individual-attendance/?staff_id=${staffId}&month=${month}&nursery_id=${nurseryId}`,
  getStaffAllAttendance: (date, nurseryId) => `${BASE_URL}/en/staff/all-attendance/?date=${date}&nursery_id=${nurseryId}`,
  room: `${BASE_URL}/en/api/nursery/classes`,
  student: `${BASE_URL}/en/api/nursery/students`,
  staff: `${BASE_URL}/en/api/manage/staff`,
  gender: `${BASE_URL}/en/api/nursery/genders`,
  nationality: `${BASE_URL}/en/api/nursery/nationalities`,
  country: `${BASE_URL}/en/api/nursery/countries`,
  programType: `${BASE_URL}/en/api/nursery/program-types/`,
  parent: `${BASE_URL}/en/api/nursery/parents`,
  staff_attendance_check: (nurseryId) => `${BASE_URL}/api/manage/attendance_check/?nursery_id=${nurseryId}`,
  student_attendance_check: () => `${BASE_URL}/api/nursery/student-checkin/`,

  // For messages page
  getAdminInbox: (nurseryId, groupType, page) => `${BASE_URL}/en/api/chat-inbox-admin/?nursery_id=${nurseryId}&group_type=${groupType}&page=${page}`,
  getGroupMessages: (groupName, page, lastMessageId) => {
    let params = '';
    if (lastMessageId) {
      params = `last_message_id=${lastMessageId}`;
    } else {
      params = `page=${page}`;
    }
    return `${BASE_URL}/en/api/chat-group/${groupName}/messages/?${params}&page_size=200`;
  },
  sendGroupMessage: (groupName) => `${BASE_URL}/en/api/chat-group/${groupName}/send-message/`,
  markGroupAsRead: (groupName) => `${BASE_URL}/en/api/chat-group/${groupName}/mark-read/`,

  // For calendar page
  rangeOfEvents: () => `${BASE_URL}/en/api/manage/events/events-range/`,
  events: `${BASE_URL}/en/api/manage/events/`,

  // Admission Form Links
  getAdmissionLinks: (nurseryId) => `${BASE_URL}/en/api/nursery/admission-links/?nursery_id=${nurseryId}`,
  generateAdmissionLink: () => 
    `${BASE_URL}/en/api/nursery/admission-links/generate-new/`,
  toggleLinkStatus: (linkId, action) => 
    `${BASE_URL}/en/api/nursery/admission-links/${linkId}/${action}/`,
  deleteAdmissionLink: (linkId) => 
    `${BASE_URL}/en/api/nursery/admission-links/${linkId}/`,
  getApplicationsOverview: (nurseryId) => 
    `${BASE_URL}/en/api/nursery/admission-applications/overview/?nursery_id=${nurseryId}`,

  // For Documents Management APIs
  createDocumentGroup: () =>
     `${BASE_URL}/en/api/nursery/document-groups/`,
  addFilesToDocumentGroup: (groupId) => 
    `${BASE_URL}/en/api/nursery/document-groups/${groupId}/add-files/`,
  getDocumentGroups: (nurseryId, target_audience, room, page = 1) =>
     `${BASE_URL}/en/api/nursery/document-groups/?nursery=${nurseryId}&target_audience=${target_audience}&room=${room}&page=${page}`,
  getDocumentGroupDetails: (groupId) =>
    `${BASE_URL}/en/api/nursery/document-groups/${groupId}/`,
  updateDocumentGroup: (groupId) => 
    `${BASE_URL}/en/api/nursery/document-groups/${groupId}/`,
  deleteDocumentGroup: (groupId) => 
    `${BASE_URL}/en/api/nursery/document-groups/${groupId}/`,
  removeDocumentFile: (groupId, fileId) =>
     `${BASE_URL}/en/api/nursery/document-groups/${groupId}/remove-file/${fileId}/`,

  // Parent Invitation API
  resendParentInvitation: (parentId) => `${BASE_URL}/en/api/nursery/parents/${parentId}/resend-invitation/`,

  // Book a Demo API
  bookDemo: () => 
    `${BASE_URL}/en/api/nursery/demo-bookings/`,

  demoBookedSlots: (dateStr) =>
    `${BASE_URL}/en/api/nursery/demo-bookings/booked-slots/?date=${dateStr}`,

  
  quranReportSummary:             "/api/nursery/report/summary",
  quranHomeworkMemorization:      "/api/nursery/report/homework/memorization/",
  quranHomeworkRevision:          "/api/nursery/report/homework/revision/",
  quranRecitationMemorization:    "/api/nursery/report/recitation/memorization/",
  quranRecitationRevision:        "/api/nursery/report/recitation/revision/",
  
};

export default API_URLS;
